<div>
  <img class="sim-logo" src="assets\sim-logo.png" alt="" />
  <div class="container">
    <div class="card">
      <!-- Left side image -->
      <div class="left">
        <img
          src="assets\gradient-intranet-illustration_23-2149368727.jpg"
          alt="Illustration"
        />
      </div>

      <!-- Right side login form -->
      <div class="right">
        <img src="assets\dexcat__4_-removebg-preview.png" alt="dexcat">
        <h2>Welcome to Dexcat!</h2>
        <h4>Sign In to your account</h4>
        <div class="input-box">
          <input type="text" placeholder="Username" />
        </div>
        <div class="input-box">
          <input type="password" placeholder="Password" />
        </div>
        <!-- <label><input type="checkbox"> Remember me</label> -->
        <button class="btn" type="button" (click)="onLogin()">Log in</button>
      </div>
    </div>
  </div>
</div>
